import React, { useEffect, useState, useContext } from "react";
// import { makeStyles, Theme, createStyles } from "@mui/styles";
// import MoreVertIcon from "@mui/icons-material/MoreVert";
// import { IconButton, Menu, MenuItem } from "@mui/material";
import { cloneDeep, defer } from "lodash";
import DefinitionSection from "~common/form/definition-section-fc";
import { makeStyles, Theme, createStyles } from "@mui/styles";
import URLManager from "~common/lib/url-manager";
import DefinitionDataProvider, { DataContext } from "~common/form/icg-definition-data-provider";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  Grid
} from "@mui/material";

import ArrowUpward from '@mui/icons-material/ArrowUpward';
import ArrowDownward from '@mui/icons-material/ArrowDownward';

import translate from "../../../components/i18n/i18n"

let selectionColor = "orange";
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    hover: {
      "&:hover": {
        backgroundColor: "#dcdbdc",
        border: "solid #b8b8b8 1px",
      },
      border: "solid #ffffff 1px",
    },
    container: {
      width: "100%",
    },
    listFunctionLine: {
      display: "flex",
      justifyContent: "space-between",
    },
    addNewRow: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    addNewRowNoResults: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: 15,
    },
    listTitle: {
      marginBottom: 10,
    },
    sectionTitle: {
      // fontSize: "0.9rem",
      marginBottom: 10,
      fontSize: "1.3125rem",
      fontWeight: 500,
      fontFamily: "Roboto,Arial,sans-serif",
      lineHeight: "1.16667em",
      paddingLeft: 8,
    },
    listFunctions: {
      display: "flex",
      justifyContent: "flex-end",
    },
    listFunctionButton: {
      // color: "#8d8d8d",
      fontSize: "1.0rem",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    listFunctionButtonIcon: {
      minWidth: "1.0rem",
    },
    criteriaSection: {
      padding: 10,
      boxShadow: "0px 0px 0px #FFFFFF;none",
    },
    paper: {
      backgroundColor: "#FFFFFF",
      boxShadow: "0px 0px 0px #FFFFFF;none",
    },
    paperNoCollapse: {
      backgroundColor: "#FFFFFF",
      boxShadow: "0px 0px 0px #FFFFFF;none",
      paddingTop: 30
    },
    summaries: {
      backgroundColor: "#FFFFFF",
      boxShadow: "0px 0px 0px #FFFFFF;none",
      padding: theme.spacing(4),
    },
    resultsSection: {
      padding: 10,
      boxShadow: "0px 0px 0px #FFFFFF;none",
    },
    noResultsSection: {
      padding: 30,
      paddingBottom: 15,
      boxShadow: "0px 0px 0px #FFFFFF;none",
      display: "flex",
      justifyContent: "center",
    },
    // An alternate to the above used when returning multiples
    resultsListSection: {
      padding: 10,
      marginTop: 15,
      boxShadow: "0px 0px 0px #FFFFFF;none",
    },
    pagerArea: {
      display: "flex",
      flexDirection: "row-reverse",
    },
    pager: {},
    evenRow: {
      backgroundColor: "#fff",
      padding: "10px 5px 5px 5px",
      borderBottom: "1px solid #ccc",
    },
    oddRow: {
      backgroundColor: "#f0f0f0",
      padding: "10px 5px 5px 5px",
      borderBottom: "1px solid #ccc",
    },
    clickableRow: {
      cursor: "pointer",
    },
    buttonBar: {
      display: "flex",
      justifyContent: "space-between",
      spaceBetween: 15,
      padding: 15,
      paddingBottom: 0,
      paddingTop: 0,
    },
    addBar: {
      display: "flex",
      justifyContent: "flex-start",
      paddingBottom: 0,
    },
    sortArea: {
      justifyContent: "flex-start",
      alignItems: "center",
      minHeight: 50,
      minWidth: 150,
    },
    sortOptions: {
      maxWidth: 300,
      minWidth: 150,
      marginRight: 30,
      width: "100%",
    },
    sortOptionIcon: {
      marginLeft: 5,
    },
    buttonArea: {
      marginTop: 15,
      justifyContent: "flex-end",
      minHeight: 50,
      minWidth: 180,
    },
    buttonSubmit: {
      marginLeft: "15px !important",
    },
    buttonAddNew: {
      marginLeft: 15,
      marginRight: 15,
      justifyContent: "flex-end",
    },
    buttonCancel: {
      paddingLeft: 15,
    },
    noResultsText: {
      display: "flex",
      justifyContent: "center",
      paddingLeft: 15,
    },
    simulationWarning: {
      border: "1px solid #fdde00",
      backgroundColor: "#fffedc",
      padding: 15,
      marginBottom: 15,
      textAlign: "center",
    },
    selectedRow: {
      border: "1px solid " + selectionColor,
      margin: 1,
    },
    summaryActionPolicyMessages: {
      border: "2px solid red",
      margin: 1,
    },
    unselectedRow: {
      border: "1px solid rgba(255,255,255,0.0)",
      margin: 1,
    },
    selectionActionArea: {
      display: "flex",
      justifyContent: "space-between",
      textAlign: "right",
      paddingLeft: 6,
      paddingRight: 5,
      paddingBottom: 5,
      verticalAlign: "baseline",
      minHeight: 45,
      marginBottom: 5,
    },
    selectionCount: {
      display: "inline-block",
      width: "40%",
      textAlign: "center",
      paddingTop: 10,
    },
    selectionAction: {
      display: "inline-block",
      width: "30%",
    },
    allSelectors: {
      display: "inline-block",
      width: "30%",
      color: "#333",
      textAlign: "left",
      paddingTop: 10,
    },
    selector: {
      color:
        theme.overrides &&
          theme.overrides.MuiButton &&
          theme.overrides.MuiButton.raisedPrimary &&
          theme.overrides.MuiButton.raisedPrimary.backgroundColor
          ? theme.overrides.MuiButton.raisedPrimary.backgroundColor
          : selectionColor,
    },
    select: {
      color:
        theme.overrides &&
          theme.overrides.MuiButton &&
          theme.overrides.MuiButton.raisedPrimary &&
          theme.overrides.MuiButton.raisedPrimary.backgroundColor
          ? theme.overrides.MuiButton.raisedPrimary.backgroundColor
          : selectionColor,
      display: "inline-block",
      cursor: "pointer",
    },
    unselect: {
      color:
        theme.overrides &&
          theme.overrides.MuiButton &&
          theme.overrides.MuiButton.raisedPrimary &&
          theme.overrides.MuiButton.raisedPrimary.backgroundColor
          ? theme.overrides.MuiButton.raisedPrimary.backgroundColor
          : selectionColor,
      display: "inline-block",
      marginLeft: 15,
      cursor: "pointer",
    },
    summaryActionMessage: {
      fontWeight: 600,
      paddingBottom: 10,
      color:
        theme.overrides &&
          theme.overrides.MuiButton &&
          theme.overrides.MuiButton.raisedPrimary &&
          theme.overrides.MuiButton.raisedPrimary.backgroundColor
          ? theme.overrides.MuiButton.raisedPrimary.backgroundColor
          : selectionColor,
      fontStyle: "italic",
    },
  })
);

interface QueryCriteriaViewProps {
  criteriaDef: any;
  onHandleSubmit: Function;
  criteriaTitleOverride?: string;
  clearButtonText: string;
  excludeFromClear: any;
  forceExecuteOnLoad: boolean;
  hasExecutedQuery: boolean;
  autoQuery: boolean;
  submitButtonText: string;
  onHandleClearClick: Function;
  variant?: "normal" | "single" | "table";
  alphabetizeSortOptions?: boolean;
  requireCriteria: boolean;
  suppressCriteriaView?: boolean;
  triggerSubmit?: Function;
  defaultCollapsed?: boolean
  preventCollapse?: boolean
}

export const QueryCriteriaView: React.FC<QueryCriteriaViewProps> = ({
  criteriaDef,
  onHandleSubmit,
  criteriaTitleOverride,
  excludeFromClear,
  hasExecutedQuery,
  forceExecuteOnLoad,
  autoQuery,
  clearButtonText,
  submitButtonText,
  onHandleClearClick,
  alphabetizeSortOptions,
  variant,
  requireCriteria,
  suppressCriteriaView,
  triggerSubmit,
  defaultCollapsed,
  preventCollapse

}) => {
  const [fullData, setFullData] = useContext(DataContext);
  const classes = useStyles();

  clearButtonText = translate(clearButtonText || "Clear")
  submitButtonText = translate(submitButtonText || "Submit")
  const renderButtonBar = () => {
    return (
      <div className={classes.buttonBar}>
        <div className={classes.sortArea}>{renderSortOptions()}</div>
        <div className={classes.buttonArea}>
          <Button
            id="clearButton"
            data-action="query-clear"
            variant="contained"
            color="inherit"
            className={classes.buttonClear}
            onClick={handleClearClick}
          >
            {clearButtonText || "Clear"}
          </Button>
          <Button
            id="submitButton"
            data-action="query-execute"
            variant="contained"
            color="primary"
            type="submit"
            disabled={requireCriteria}
            className={classes.buttonSubmit}
            onClick={handleSubmit}
          >
            {submitButtonText || "Submit"}
          </Button>
        </div>
      </div>
    );
  };

  const handleClearClick = () => {
    var ensureFullData = fullData || {};

    var crit = {};
    // check if fields have been excluded from being cleared.
    if (excludeFromClear && excludeFromClear.length > 0) {
      // loop over excluded fields
      excludeFromClear.forEach((c) => {
        if (ensureFullData[c]) {
          // field exists on top-level object
          crit[c] = ensureFullData[c];
        } else {
          // field doesn't exist on top level object
          // check to see if field is nested.
          Object.keys(ensureFullData).forEach((k) => {
            if (typeof ensureFullData[k] === "object") {
              if (ensureFullData[k] && ensureFullData[k][c]) {
                if (!crit[k]) {
                  crit[k] = {};
                }
                crit[k][c] = ensureFullData[k][c];
              }
            }
          });
        }
      });
    setFullData(crit)
    } else {
      if (onHandleClearClick) {
        onHandleClearClick()
      }
    }
  };

  const translateSortOption = (sortString: string) => {
    var sortOption = <i>{sortString}</i>;

    if (sortString.indexOf("A-Z") > -1) {
      sortOption = (<i style={{ width: '100%' }}>{sortString.replace("(A-Z)", "")} <i style={{ position: 'absolute', right: 18 }}>&#8595;</i></i>)
      sortOption = <i>&#8595; {sortString}</i>
    } else if (sortString.indexOf("Z-A") > -1) {
      sortOption = (<i style={{ width: '100%' }}>{sortString.replace("(Z-A)", "")} <i style={{ position: 'absolute', right: 18 }}>&#8593;</i></i>)
    } else if (sortString.indexOf("Oldest-Newest") > -1) {
      sortOption = (<i style={{ width: '100%' }}>{sortString.replace("(Oldest-Newest)", "")} <i style={{ position: 'absolute', right: 18 }}>&#8595;</i></i>)
    } else if (sortString.indexOf("Newest-Oldest") > -1) {
      sortOption = (<i style={{ width: '100%' }}>{sortString.replace("(Newest-Oldest)", "")} <i style={{ position: 'absolute', right: 18 }}>&#8593;</i></i>)
    } else if (sortString.indexOf("Lowest-Highest") > -1) {
      sortOption = (<i style={{ width: '100%' }}>{sortString.replace("(Lowest-Highest)", "")} <i style={{ position: 'absolute', right: 18 }}>&#8595;</i></i>)
    } else if (sortString.indexOf("Highest-Lowest") > -1) {
      sortOption = (<i style={{ width: '100%' }}>{sortString.replace("(Highest-Lowest)", "")} <i style={{ position: 'absolute', right: 18 }}>&#8593;</i></i>)
    }

    return sortOption;
  }

  const onSortSelect = (evt: any) => {
    const newFullData = cloneDeep(fullData || {});
    if (evt && evt.target && evt.target.dataset) {
      newFullData.sortBy = evt.target.dataset["sort"];
      newFullData.sortDirection = evt.target.dataset["dir"];
    } else {
      newFullData.sortBy = null;
      newFullData.sortDirection = null;
    }
    setFullData(newFullData);
    // console.warn("TODO:  Implement This");
    // this.setState({ criteria: criteria }, () => {
    //   // Make sure and update the URL, even though we will manually trigger the execute manually by passing true as the  `silent`
    //   if (!this.props.suppressURL) {
    //     delete criteria.criteriaForm;
    //     delete criteria.resultsForm;
    //     URLManager.putQueryString(this.state.criteria, true);
    //   } else {
    //     this.executeQuery(criteria);
    //   }
    // });
  };

  const renderSortOptions = (): any => {
    var sortOptions: any = null;

    // Get the preferred language defaulting to english
    var lang = "en-US"
    if ((window as any).App.userContext && (window as any).App.userContext.extendedAttributes) {
      if ((window as any).App.userContext.extendedAttributes.preferredLanguage) {
        lang = (window as any).App.userContext.extendedAttributes.preferredLanguage
      }
    }

    if (variant == "single") {
      return null;
    }

    if (alphabetizeSortOptions) {
      criteriaDef.sortOptions.sort(function (a, b) {
        if (a.label < b.label) {
          return -1
        }
        if (a.label > b.label) {
          return 1
        }

        return 0
      })
    }
    var selectFullData = cloneDeep(fullData || {});

    if (criteriaDef && criteriaDef.sortOptions) {
      sortOptions = (
        <FormControl name="sortByControl" className={classes.sortOptions}>
          <InputLabel shrink htmlFor="sortBy">
            {translate("Sort By")}
          </InputLabel>
          <Select
            style={{ minWidth: 250 }}
            id="sortBy"
            name="sortBy"
            data-action="query-sort"
            value={(selectFullData["sortBy"] && selectFullData["sortDirection"]) ? `${selectFullData["sortBy"]}|${selectFullData["sortDirection"]}` : ""}
          >
            {<MenuItem value="" />}
            {criteriaDef.sortOptions.map((c: any, idx: number) => {
              return (
                <MenuItem
                  data-sort={c["sortByKey"]}
                  data-dir={c["sortDirection"]}
                  id={"so" + idx}
                  key={idx}
                  value={`${c["sortByKey"]}|${c["sortDirection"]}`}
                  onClick={onSortSelect}
                >
                  {lang == "en-US" && c.label}

                  {lang != "en-US" && c.label.indexOf("(A-Z)") > -1 && <>{c.label.replace("(A-Z)", "")} <ArrowDownward fontSize="small" sx={{ position: "absolute", right: 20 }} /></>}
                  {lang != "en-US" && c.label.indexOf("(Z-A)") > -1 && <>{c.label.replace("(Z-A)", "")} <ArrowUpward fontSize="small" sx={{ position: "absolute", right: 20 }} /></>}

                  {lang != "en-US" && c.label.indexOf("(Lowest-Highest)") > -1 && <>{c.label.replace("(Lowest-Highest)", "")} <ArrowDownward fontSize="small" sx={{ position: "absolute", right: 20 }} /></>}
                  {lang != "en-US" && c.label.indexOf("(Highest-Lowest)") > -1 && <>{c.label.replace("(Highest-Lowest)", "")} <ArrowUpward fontSize="small" sx={{ position: "absolute", right: 20 }} /></>}

                  {lang != "en-US" && c.label.indexOf("(Oldest-Newest)") > -1 && <>{c.label.replace("(Oldest-Newest)", "")} <ArrowDownward fontSize="small" sx={{ position: "absolute", right: 20 }} /></>}
                  {lang != "en-US" && c.label.indexOf("(Newest-Oldest)") > -1 && <>{c.label.replace("(Newest-Oldest)", "")} <ArrowUpward fontSize="small" sx={{ position: "absolute", right: 20 }} /></>}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      );
    }


    return sortOptions;
  };

  const handleSubmit = (evt: any) => {
    if (evt && !evt.auto) {
      document.getElementById("submitButton").focus();
    } else {
      if (onHandleSubmit) {
        onHandleSubmit(fullData)
      }
    }
  };

  const onFormSubmit = (evt: any) => {

    evt.nativeEvent.preventDefault();
    evt.stopPropagation();

    if (onHandleSubmit) {
      onHandleSubmit(fullData)
    }

    return false;
  };

  var qsCrit = URLManager.getQueryString() || {};
  useEffect(() => {
    setFullData(qsCrit)
    if (
      (forceExecuteOnLoad ||
        (autoQuery && Object.keys(qsCrit).length > 0)) && !hasExecutedQuery
    ) {

      setTimeout(() => {
        handleSubmit({ auto: true });
      }, 100)
    }

  }, []);

  if (!preventCollapse) {
    return (
      <Accordion
        defaultExpanded={!defaultCollapsed}
        className={classes.criteriaSection}
        style={{ display: suppressCriteriaView ? 'none' : '' }}
      >
        <AccordionSummary
          className={classes.paper}
          expandIcon={<ExpandMoreIcon />}
        >
          <Typography
            className={classes.sectionTitle}
            variant="h6"
          >
            {criteriaTitleOverride || criteriaDef.title}
          </Typography>
        </AccordionSummary>
        <AccordionDetails className={classes.paper}>
          <form noValidate
            style={{ width: "100%" }}
            onSubmit={onFormSubmit}
          >
            <DefinitionSection
              definition={criteriaDef}
              embedded={true}
              titleOverride={criteriaTitleOverride}
              // path={``}
              //   policyMessages={policyMessages}
              suppressTitle={false}
              suppressFirstTitle={true}
              triggerSubmit={triggerSubmit}
            />
            {renderButtonBar()}
          </form>
        </AccordionDetails>
      </Accordion>
    );
  } else {
    return (
      <Grid className={classes.paperNoCollapse} style={{ display: suppressCriteriaView ? 'none' : '' }}>
        <Typography
          className={classes.sectionTitle}
          variant="h6"
        >
          {criteriaTitleOverride || criteriaDef.title}
        </Typography>
        <form noValidate
          style={{ width: "100%" }}
          onSubmit={onFormSubmit}
        >
          <DefinitionSection
            definition={criteriaDef}
            embedded={true}
            titleOverride={criteriaTitleOverride}
            // path={``}
            //   policyMessages={policyMessages}
            suppressTitle={false}
            suppressFirstTitle={true}
            triggerSubmit={triggerSubmit}
          />
          {renderButtonBar()}
        </form>
      </Grid>
    );
  }



};

export default QueryCriteriaView;